export default __webpack_public_path__ + "static/media/ic-edit.44698038.svg";